import Delegate from "//okr-qa.ovh/cdn/shop/t/2/assets/ftdomdelegate.min.js?v=85864865866317895671655307500";

export class LandingProductsSubscription extends HTMLElement {
  connectedCallback() {
    this._attachListeners();
    document.addEventListener('product:added', this._resetProduct.bind(this));
  }

  _attachListeners() {
    // Quantity
    new Delegate(this).on('click', '[data-action="increase-quantity"]', this._updateQuantity.bind(this));
    new Delegate(this).on('click', '[data-action="decrease-quantity"]', this._updateQuantity.bind(this));
    // toggle-delivery
    new Delegate(this).on('click', '[data-action="toggle-delivery"]', this._toogleDelivery.bind(this));
    new Delegate(this).on('click', '[data-element="subscription-frequency-item"]', this._changeDelivery.bind(this));
    new Delegate(this).on('mouseover', '[data-element="subscription-frequency-item"]', this._displayDeliveryMessage.bind(this));
    new Delegate(this).on('mouseout', '[data-element="subscription-frequency-item"]', this._displaySelectedDeliveryMessage.bind(this));

  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  _resetProduct(event, target) {
    let quantityInput = this.querySelector('.quantity-selector__value');
    let minusButton = this.querySelector('[data-action="decrease-quantity"]');
    let quantityPack = this.querySelector('[data-element="pack-quantity"]');
    let subscriptionPrice = this.querySelectorAll('button [data-element="subscription-price"]');
    let deliveryMessages = this.querySelectorAll('[data-element="subscription-frequency-message"]');
    let gtmQuantity = this.querySelector('button[type="submit"][data-gtm-quantity]');
    let subscriptionButton = this.querySelector('button[type="submit"][data-quantity]');
    let subscriptionButtons = this.querySelector('[data-frequency] i');
    let deliveryItems = this.querySelectorAll('[data-element="subscription-frequency-item"]');
    let propertiesFrequency = this.querySelector('[name="properties[shipping_interval_frequency]"]');
    let subscriptionFrequency = this.querySelector('[data-element="subscription-frequency"]');
    let initialQuantity = 1;

    if (quantityPack) {
      initialQuantity = parseInt(quantityPack.getAttribute('data-quantity'));
    }

    // cleanup degressive-price injected spans and restore compare-at-price
    this.querySelectorAll('.dp-regular-price, .dp-sub-regular-price').forEach(function(el) { el.remove(); });
    this.querySelectorAll('[data-element="compare-at-price"]').forEach(function(el) { el.style.display = ''; });

    // reset card price display to initial subscription price
    var cardPriceSpan = this.querySelector('[data-element="price"]');
    if (cardPriceSpan) {
      var subPrice = parseInt(cardPriceSpan.getAttribute('data-sub-price') || cardPriceSpan.getAttribute('data-price'), 10);
      if (subPrice) {
        cardPriceSpan.innerHTML = (subPrice / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
        cardPriceSpan.classList.remove('sale-price');
      }
    }

    if (quantityInput) {
      quantityInput.value = 1;
    }

    if (gtmQuantity) {
      gtmQuantity.setAttribute('data-gtm-quantity', '1');
    }

    if (subscriptionButton) {
      subscriptionButton.setAttribute('data-quantity', '1');
      subscriptionButton.setAttribute('data-frequency', '1');
    }

    if (subscriptionButtons) {
      subscriptionButtons.innerText = "";
    }
    if (minusButton) {
      minusButton.setAttribute('disabled', 'disabled');
    }

    if (quantityPack) {
      quantityPack.innerHTML = '' + initialQuantity + '';
    }

    if (subscriptionPrice.length > 0) {
      for (let _i2 = 0; _i2 < subscriptionPrice.length; _i2++) {
        let initialSubscriptionPrice = subscriptionPrice[_i2].getAttribute('data-price') / 100;
        subscriptionPrice[_i2].innerHTML = (initialSubscriptionPrice).toFixed(2).replace('.', ',') + '€';
      }
    }

    if (deliveryMessages.length > 0) {
      for (let _i3 = 0; _i3 < deliveryMessages.length; _i3++) {
        let currentMessage = deliveryMessages[_i3].querySelector('.rc_frequency-message-container');

        let startMessage = currentMessage.innerHTML.split('<span class="delivery-quantity">')[0];
        let endMessage = currentMessage.innerHTML.split('</span>')[1];
        let newMessage = startMessage + '<span class="delivery-quantity">';

        newMessage += window.theme.productSubscription.is_pack_single.replace('<b></b>', '<b>' + initialQuantity + '</b>') + '</span>' + endMessage;
        currentMessage.innerHTML = newMessage;

        if (_i3 == 0) {
          deliveryMessages[_i3].classList.add('active');
        } else {
          deliveryMessages[_i3].classList.remove('active');
        }
      }
    }

    if (deliveryItems.length > 0) {
      for (let i = 0; i < deliveryItems.length; i++) {
        if (i == 0) {
          deliveryItems[i].classList.add('active');
        } else {
          deliveryItems[i].classList.remove('active');
        }
      }
    }

    if (propertiesFrequency) {
      propertiesFrequency.value = '1';
    }

    if (subscriptionFrequency) {
      subscriptionFrequency.innerHTML = '1';
    }

  }

  _changeDelivery(event, target) {
    let deliveryItems = this.querySelectorAll('[data-element="subscription-frequency-item"]');
    let deliveryMessages = this.querySelectorAll('[data-element="subscription-frequency-message"]');
    let subscriptionButton = this.querySelector('[data-frequency] i');
    let subscriptionSubmit = this.querySelector('[data-frequency]');
    let sellingPlan = target.getAttribute('data-selling-id');
    let index0 = parseInt(target.getAttribute('data-index'));
    let index = index0 + 1;

    for (let i = 0; i < deliveryItems.length; i++) {
      deliveryItems[i].classList.remove('active');
    }

    deliveryItems[index0].classList.add('active');

    for (let _i = 0; _i < deliveryMessages.length; _i++) {
      deliveryMessages[_i].classList.remove('active');
    }

    deliveryMessages[index0].classList.add('active');
    //this.querySelector('[name="properties[shipping_interval_frequency]"]').value = index;
    subscriptionSubmit.setAttribute('data-selling-plan', sellingPlan);
    subscriptionButton.innerText = index === 1 ? '' : ' ' + index;
    this.querySelector('[data-element="subscription-frequency"]').innerHTML = '' + index + '';
  }

  _displayDeliveryMessage(event, target) {
    let deliveryMessages = this.querySelectorAll('[data-element="subscription-frequency-message"]');
    let index0 = parseInt(target.getAttribute('data-index'));

    for (let i = 0; i < deliveryMessages.length; i++) {
      deliveryMessages[i].classList.remove('active');
    }

    deliveryMessages[index0].classList.add('active');
  }

  _displaySelectedDeliveryMessage(event, target) {
    let deliveryMessages = this.querySelectorAll('[data-element="subscription-frequency-message"]');
    let index0 = parseInt(this.querySelector('[data-element="subscription-frequency-item"].active').getAttribute('data-index'));

    for (var i = 0; i < deliveryMessages.length; i++) {
      deliveryMessages[i].classList.remove('active');
    }

    deliveryMessages[index0].classList.add('active');
  }

  _toogleDelivery(event) {
    if (event) event.preventDefault();
    let frequencyElement = this.querySelector('.rc_block__type__options');
    if (frequencyElement.getAttribute('data-close') == 'true') {
      document.querySelectorAll('#subscription-delivery').forEach(function (value, index) {
        value.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('.rc_block__type__options').forEach(function (value, index) {
        value.setAttribute('aria-expanded', 'true');
        value.setAttribute('data-close', 'true');
      })
    }
    let delivery = frequencyElement.getAttribute('aria-controls');
    let deliveryElement = this.querySelector('#' + delivery);
    frequencyElement.setAttribute('data-close', frequencyElement.getAttribute('data-close') === 'true' ? 'false' : 'true');
    deliveryElement.setAttribute('aria-hidden', deliveryElement.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
    frequencyElement.setAttribute('aria-expanded', frequencyElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    if (window.matchMedia('(max-width:1023px)').matches) {
      let overlay = this.querySelector('.overlay');
      if (overlay) {
        overlay.setAttribute('aria-hidden', overlay.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    }
  }

  _updateQuantity(event, target) {
    let quantityInput = this.querySelector('.quantity-selector__value');
    let minusButton = this.querySelector('[data-action="decrease-quantity"]');
    let quantityPack = this.querySelector('[data-element="pack-quantity"]');
    let subscriptionPrice = this.querySelectorAll('button [data-element="subscription-price"]');
    let deliveryMessages = this.querySelectorAll('[data-element="subscription-frequency-message"]');
    let gtmQuantity = this.querySelector('button[type="submit"][data-gtm-quantity]');
    let subscriptionButton = this.querySelector('button[type="submit"][data-quantity]');
    let initialQuantity = 1;

    if (quantityPack) {
      initialQuantity = parseInt(quantityPack.getAttribute('data-quantity'));
    } // change input quantity


    if (target.getAttribute('data-action') === 'decrease-quantity') {
      quantityInput.value = parseInt(quantityInput.value) - 1;
    } else {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    }

    if (gtmQuantity) {
      gtmQuantity.setAttribute('data-gtm-quantity', quantityInput.value);
    }

    if (subscriptionButton) {
      subscriptionButton.setAttribute('data-quantity', quantityInput.value);
    }

    // disable minus button if qty is 1
    if (parseInt(quantityInput.value) === 1) {
      minusButton.setAttribute('disabled', 'disabled');
    } else {
      minusButton.removeAttribute('disabled');
    }
    // update quantity pack
    if (quantityPack) {
      quantityPack.innerHTML = '' + initialQuantity * quantityInput.value + '';
    }

    if (subscriptionPrice.length > 0 && !this.querySelector('degressive-price')) {
      for (let _i2 = 0; _i2 < subscriptionPrice.length; _i2++) {
        let initialSubscriptionPrice = subscriptionPrice[_i2].getAttribute('data-price') / 100;
        subscriptionPrice[_i2].innerHTML = (initialSubscriptionPrice * quantityInput.value).toFixed(2).replace('.', ',') + '€';
      }
    }
    if (deliveryMessages.length > 0) {
      for (let _i3 = 0; _i3 < deliveryMessages.length; _i3++) {
        let currentMessage = deliveryMessages[_i3].querySelector('.rc_frequency-message-container');

        let startMessage = currentMessage.innerHTML.split('<span class="delivery-quantity">')[0];
        let endMessage = currentMessage.innerHTML.split('</span>')[1];
        let totalQuantity = initialQuantity * quantityInput.value;
        let newMessage = startMessage + '<span class="delivery-quantity">';

        if (quantityInput.value > 1) {
          let newQuantity = window.theme.productSubscription.is_pack_multiple.replace('<i></i>', '<i>' + quantityInput.value + '</i>');
          newQuantity = newQuantity.replace('<b></b>', '<b>' + totalQuantity + '</b>');
          newMessage += newQuantity + '</span>' + endMessage;
        } else {
          newMessage += window.theme.productSubscription.is_pack_single.replace('<b></b>', '<b>' + initialQuantity + '</b>') + '</span>' + endMessage;
        }

        currentMessage.innerHTML = newMessage;
      }
    }

  }

}

export class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    this.buttonElement.addEventListener('click', this._showMore.bind(this));

    document.addEventListener('popup:toggle', (event) => {
      let overlay = document.getElementById('overlay');

      event.detail.popup.hidden = false;
      overlay.setAttribute('aria-hidden', (event.detail.hideOverlay) ? 'true' : 'false');
      overlay.setAttribute('aria-controls', this.buttonElement.getAttribute('aria-controls'));
    });
  }

  get handle() {
    return this.buttonElement.getAttribute('data-handle')
  }

  get controlledPopup() {
    return document.getElementById(this.buttonElement.getAttribute('aria-controls'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }

  async _showMore() {
    const response = await fetch(`${Shopify.routes.root}products/${this.handle}?section_id=cure-product-info`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    const responseText = await response.text();

    if (response.ok) {
      this.controlledPopup.innerHTML = responseText;

      this.dispatchEvent(new CustomEvent(`popup:toggle`, {
        bubbles: true,
        detail: {
          popup: this.controlledPopup
        }
      }));
    }
  }
}

export class PopupInfo extends HTMLElement {
  constructor() {
    super();
  }

  get hidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  set hidden(value) {
    this.setAttribute('aria-hidden', (value) ? 'true' : 'false');
  }
}

export class TogglePopup extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      this.controlledElement.hidden = !this.controlledElement.hidden;

      if (this.controlledOverlay) this.controlledOverlay.setAttribute('aria-hidden', this.controlledOverlay.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
    });
  }

  get controlledElement() {
    return document.getElementById(this.buttonElement.getAttribute('aria-controls'));
  }

  get controlledOverlay() {
    return document.getElementById(this.buttonElement.getAttribute('data-overlay'));
  }

  get buttonElement() {
    return this.querySelector('button');
  }
}

if (!window.customElements.get('landing-product-subscription')) {
  window.customElements.define('landing-product-subscription', LandingProductsSubscription);
}

if (!window.customElements.get('popup-info')) {
  window.customElements.define('popup-info', PopupInfo);
}

if (!window.customElements.get('show-more-button')) {
  window.customElements.define('show-more-button', ShowMoreButton);
}

if (!window.customElements.get('toggle-popup')) {
  window.customElements.define('toggle-popup', TogglePopup);
}